import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Container } from '@material-ui/core';
import ChildSearchBar from './SearchChildBar';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import { useProductStyles } from '../../../styles/js/itemStyles';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddChilds(props, item) {

  const classes = useStyles();
  const classe = useProductStyles();
  const { open, setOpen } = props

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  // const itemState = useSelector(state => {
  //   return state.item;
  // })



  return (
    <div>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              AJOUTER LES ENFANTS
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              SAVE
            </Button>
          </Toolbar>
        </AppBar>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classe.button}
          startIcon={<AddSharpIcon />}
          style={{marginLeft: 15, marginTop: 20, backgroundColor: "#2196f3",  width: "max-content"}}
        >
          Nouveau Child
        </Button>

        <Container style={{ margin: "0 auto", marginTop: 50 }}>
          <div style={{ marginLeft: 20, width: "max-content" }}>
            <ChildSearchBar />
          </div>
          <div style={{ marginLeft: 20, marginTop: 20, width: "max-content" }}>
          </div>
        </Container>

      </Dialog>
    </div>
  );
}
